import { render, staticRenderFns } from "./DetalleSolicitudAMEX.vue?vue&type=template&id=39637822&"
import script from "./DetalleSolicitudAMEX.vue?vue&type=script&lang=js&"
export * from "./DetalleSolicitudAMEX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetalleSolicitudAMEX.vue"
export default component.exports